<template>
  <div>
    <v-btn
      :class="styles"
      @click="clickHandler"
      :disabled="disabled"
      flat
      small
      icon
      color="red"
    >
      <v-icon>delete_forever</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { showLabelOnHover } from '@/components/Shared/Button/iconButtonStyles'

export default {
  name: 'AppDeleteButton',
  props: {
    status: {
      type: Boolean,
      default: false,
    },
    withLabel: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clickHandler: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    styles() {
      return this.withLabel ? showLabelOnHover('削除') : null
    },
  },
}
</script>

<style scoped></style>
